import React, { useEffect, useState } from "react";
import { Button, Card, Tabs } from "antd";
import "./InstructorForm.scss";
import Buttons from "../../../Components/Buttons/Buttons";
import FormInputs from "../../../Components/FormInputs/FormInputs";
import TextArea from "antd/es/input/TextArea";
import { LeftCircleOutlined } from "@ant-design/icons";
import SelectInputs from "../../../Components/SelectInputs/SelectInputs";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getApi, postApi } from "../../../Utlis/apiService";
import {
  ADD_NEW_INSTRUCTOR,
  GET_CATEGORY_DROPDOWN,
  GET_INSTRUCTOR_SLOTS,
  UPDATE_INSTRUCTOR_SLOTS,
  UPDATE_INSTRUCTORS,
} from "../../../Utlis/apiPath";
import { errorToast, successToast } from "../../../Services/ToastHelper";
import Loader from "../../../Components/Loader/Loader";
import { Checkbox, Select, Switch } from "antd";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { BackArrowIcon } from "../../../Components/Icons/BackArrowIcon";
import MultiSelectInput from "../../../Components/MultiSelectInput/MultiSelectInput";
import WeeklySchedule from "../../../Components/InstructorWeeklySchedule/WeeklySchedule";

const { TabPane } = Tabs;

const DAYS_OF_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const buildEmptySchedule = () =>
  DAYS_OF_WEEK.reduce((acc, day) => {
    acc[day] = {
      isActive: false,
      onlineActive: false,
      offlineActive: false,
      online: [{ start: null, end: null, slotType: 1 }],
      offline: [{ start: null, end: null, slotType: 2 }],
    };
    return acc;
  }, {});

const initialValues = {
  firstName: "",
  lastName: "",
  emailId: "",
  mobileNumber: "",
  countryCode: "",
  aboutMe: "",
  gender: "",
  education: "",
  experience: "",
  expertise: "",
  registrationFee: "",
  securityFee: "",
  expectedPerSessionFee: "",
  finalPerSessionFee: "", // Add new field
};
const InstructorForm = ({
  setShowAddInstructorForm,
  updateData,
  setUpdateData,
  fetchTableData,
  addInstructorForm,
  isClassManagementSection,
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [selectedValue, setSelectedValue] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState();

  const patchFormData = (updateData) => {
    const updatedValues = {
      firstName: updateData.firstName || "",
      lastName: updateData.lastName || "",
      emailId: updateData.mailId || "",
      mobileNumber: updateData.mobileNo || "",
      countryCode: "+1", // Default or retain existing value
      aboutMe: updateData.aboutMe || "",
      gender: updateData.gender || "",
      education: updateData.education || "",
      experience: updateData.experience || "",
      expertise: updateData.expertise || "",
      registrationFee: updateData.registrationFee || "",
      securityFee: updateData.securityFee || "",
      expectedPerSessionFee: updateData.expectedPerSessionFee || "",
    };

    setFormData((prevState) => ({
      ...prevState,
      ...updatedValues,
    }));
  };

  useEffect(() => {
    fetchInstructorSlots(updateData?.instructorId, "standard", setSchedule);
    fetchInstructorSlots(updateData?.instructorId, "daylight", setDaylightSchedule);
  }, [updateData]);

  const patchScheduleData = (slotsData, targetSetSchedule) => {
    const updatedSchedule = buildEmptySchedule();

    slotsData.forEach(({ day, slotType, id, startTime, endTime }) => {
      if (!updatedSchedule[day]) return;

      const mode = slotType === 1 ? "online" : "offline";
      updatedSchedule[day].isActive = true;
      if (mode === "online") updatedSchedule[day].onlineActive = true;
      if (mode === "offline") updatedSchedule[day].offlineActive = true;

      if (
        updatedSchedule[day][mode].length === 1 &&
        updatedSchedule[day][mode][0].start === null
      ) {
        updatedSchedule[day][mode] = [];
      }

      updatedSchedule[day][mode].push({
        id,
        start: startTime,
        end: endTime,
        slotType,
        isPatched: true,
      });
    });

    Object.keys(updatedSchedule).forEach((day) => {
      ["online", "offline"].forEach((mode) => {
        updatedSchedule[day][mode].sort((a, b) => {
          if (!a.start || !b.start) return 0;
          return a.start.localeCompare(b.start);
        });
      });
    });

    targetSetSchedule(updatedSchedule);
  };
  const fetchInstructorSlots = async (id, mode, targetSetSchedule) => {
    setIsLoading(true);
    const params = {
      instructorId: id,
      mode,
    };
    const { status, data } = await getApi(GET_INSTRUCTOR_SLOTS, {
      params,
    });
    if (status === 200) {
      patchScheduleData(data, targetSetSchedule);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  // Call the function with the first entry in updateData
  useEffect(() => {
    if (updateData?.length > 0) {
      patchFormData(updateData[0]);
    }
  }, [updateData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const [schedule, setSchedule] = useState(buildEmptySchedule);
  const [daylightSchedule, setDaylightSchedule] = useState(buildEmptySchedule);
  const [removedSlotIds, setRemovedSlotIds] = useState([]);

  const handleDeleteSlot = (slotId) => {
    setRemovedSlotIds((prev) => (prev.includes(slotId) ? prev : [...prev, slotId]));
  };

  const handlePhoneChange = (value, country) => {
    setFormData({
      ...formData,
      mobileNumber: value.slice(country.dialCode.length),
      countryCode: `+${country.dialCode}`,
    });
    if (formData.mobileNumber) {
      setErrors((prevErrors) => ({ ...prevErrors, mobileNumber: "" }));
    }
  };

  const validateFields = () => {
    let errObj = {};

    if (!formData.firstName.trim()) {
      errObj.firstName = "First Name is required";
    }
    if (!formData.lastName.trim()) {
      errObj.lastName = "Last Name is required";
    }
    if (!formData.emailId.trim()) {
      errObj.emailId = "Email is required";
    } else if (/\s/.test(formData.emailId)) {
      errObj.emailId = "Email should not contain spaces";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.emailId)) {
      errObj.emailId = "Please enter a valid email address";
    }
    if (!formData.mobileNumber.trim()) {
      errObj.mobileNumber = "Mobile Number is required";
    }
    // if (!formData.aboutMe.trim()) {
    //   errObj.aboutMe = "This field is required";
    // }
    if (!formData.gender.trim()) {
      errObj.gender = "Gender is required";
    }
    if (!formData.education.trim()) {
      errObj.education = "Education is required";
    }
    if (!formData.experience.trim()) {
      errObj.experience = "Experience is required";
    }
    // if (!formData.expertise.trim()) {
    //   errObj.expertise = "Expertise is required";
    // }
    if (!formData.registrationFee) {
      errObj.registrationFee = "Registration Fee is required";
    } else if (
      isNaN(formData.registrationFee) ||
      formData.registrationFee <= 0
    ) {
      errObj.registrationFee = "Please enter a valid Registration Fee";
    }
    if (
      formData.securityFee &&
      (isNaN(formData.securityFee) || formData.securityFee <= 0)
    ) {
      errObj.securityFee = "Please enter a valid Security Fee";
    }
    // Remove required validation for expectedPerSessionFee
    if (
      formData.expectedPerSessionFee &&
      (isNaN(formData.expectedPerSessionFee) ||
        formData.expectedPerSessionFee <= 0)
    ) {
      errObj.expectedPerSessionFee =
        "Please enter a valid Expected Per Session Fee";
    }
    // Add validation for finalPerSessionFee if needed (optional, so skip required)
    if (
      formData.finalPerSessionFee &&
      (isNaN(formData.finalPerSessionFee) || formData.finalPerSessionFee <= 0)
    ) {
      errObj.finalPerSessionFee =
        "Please enter a valid Approved Per Session Fee";
    }

    const isValid = Object.keys(errObj).length === 0;

    setErrors(errObj);
    return isValid;
  };

  const findIncompleteSlot = (scheduleObj) => {
    for (const day of Object.keys(scheduleObj)) {
      const dayData = scheduleObj[day];
      for (const mode of ["online", "offline"]) {
        const slots = dayData[mode] || [];
        for (const slot of slots) {
          if (Boolean(slot.start) !== Boolean(slot.end)) {
            return { day, mode };
          }
        }
      }
    }
    return null;
  };

  const mapScheduleToSlots = (scheduleObj) =>
    Object.keys(scheduleObj)
      .map((day) => {
        const dayData = scheduleObj[day];
        const daySlots = [];

        if (dayData.onlineActive) {
          daySlots.push(
            ...dayData.online
              .filter((slot) => slot.start && slot.end)
              .map((slot) => ({
                startTime: slot.start,
                endTime: slot.end,
                slotType: 1,
              }))
          );
        }

        if (dayData.offlineActive) {
          daySlots.push(
            ...dayData.offline
              .filter((slot) => slot.start && slot.end)
              .map((slot) => ({
                startTime: slot.start,
                endTime: slot.end,
                slotType: 2,
              }))
          );
        }

        return daySlots.length > 0
          ? {
              days: day,
              startEndTime: daySlots,
            }
          : null;
      })
      .filter((slot) => slot !== null);

  const handleSubmit = async () => {
    if (validateFields()) {
      const incompleteSlot =
        findIncompleteSlot(schedule) || findIncompleteSlot(daylightSchedule);
      if (incompleteSlot) {
        errorToast(
          `Please enter both start and end time for the ${incompleteSlot.mode} slot on ${incompleteSlot.day}, or clear it.`
        );
        return;
      }

      const mappedSlots = mapScheduleToSlots(schedule);
      const mappedDaylightSlots = mapScheduleToSlots(daylightSchedule);

      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.emailId,
        countryCode: formData.countryCode,
        phoneNumber: formData.mobileNumber,
        gender: formData.gender,
        aboutMe: formData.aboutMe,
        education: formData.education,
        experienceYears: formData.experience,
        experties: formData.expertise,
        registrationFee: parseFloat(formData.registrationFee),
        securityFee: parseFloat(formData.securityFee),
        expectedPerSessionFee: parseFloat(formData.expectedPerSessionFee),
        finalPerSessionFee: parseFloat(formData.finalPerSessionFee),
        slots: mappedSlots,
        daylightSlots: mappedDaylightSlots,
        mode: "standard",
      };
      setIsLoading(true);
      try {
        const { status, message } = await postApi(ADD_NEW_INSTRUCTOR, payload);
        if (status === 200) {
          setShowAddInstructorForm(false);
          successToast(message);
          !isClassManagementSection && fetchTableData();
        } else {
          errorToast(message);
        }
      } catch (error) {
        console.error("Error adding instructor:", error);
        errorToast("Something went wrong!");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleUpdate = async () => {
    if (validateFields()) {
      // Proceed only if validation passes
      const incompleteSlot =
        findIncompleteSlot(schedule) || findIncompleteSlot(daylightSchedule);
      if (incompleteSlot) {
        errorToast(
          `Please enter both start and end time for the ${incompleteSlot.mode} slot on ${incompleteSlot.day}, or clear it.`
        );
        return;
      }

      const mappedSlots = mapScheduleToSlots(schedule);
      const mappedDaylightSlots = mapScheduleToSlots(daylightSchedule);

      const payload = {
        instructorId: updateData[0]?.instructorId,
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.emailId,
        countryCode: formData.countryCode,
        phoneNumber: formData.mobileNumber,
        gender: formData.gender,
        aboutMe: formData.aboutMe,
        education: formData.education,
        experienceYears: formData.experience,
        experties: formData.expertise,
        registrationFee: parseFloat(formData.registrationFee),
        securityFee: parseFloat(formData.securityFee),
        expectedPerSessionFee: parseFloat(formData.expectedPerSessionFee),
        finalPerSessionFee: parseFloat(formData.finalPerSessionFee),
        slots: mappedSlots,
        mode: "standard",
      };

      setIsLoading(true);
      try {
        const { status, message } = await postApi(UPDATE_INSTRUCTORS, payload);
        if (status === 200) {
          const instructorId = updateData[0]?.instructorId;
          if ((mappedDaylightSlots.length > 0 || removedSlotIds.length > 0) && instructorId) {
            await postApi(UPDATE_INSTRUCTOR_SLOTS, {
              instructorId,
              slots: mappedDaylightSlots,
              prevSlotIds: removedSlotIds,
              mode: "daylight",
            });
            setRemovedSlotIds([]);
          }
          setShowAddInstructorForm(false);
          successToast(message);
          fetchTableData();
          setUpdateData();
        } else {
          errorToast(message);
        }
      } catch (error) {
        console.error("Error updating instructor:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const hanldeBack = () => {
    setShowAddInstructorForm(false);
  };

  const handleSelectChange = (value) => {
    setSelectedValue(value);
  };

  const options = [
    { value: "1", label: "YinYoga" },
    { value: "2", label: "Meditation" },
    { value: "3", label: "Hatha" },
    { value: "4", label: "Vinyasa Flow" },
  ];

  useEffect(() => {
    fetchCategoryDropDown();
  }, []);

  const fetchCategoryDropDown = async () => {
    setIsLoading(true);
    try {
      const url = `${GET_CATEGORY_DROPDOWN}`;
      const { status, message, data } = await getApi(url);
      if (status === 200) {
        setSelectedCategory(data);
      } else {
        setSelectedCategory([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
      setSelectedCategory([]);
    } finally {
      setIsLoading(false);
    }
  };

  const categoryOptions = selectedCategory?.map((category) => ({
    label: category.name.trim(),
    value: category.id,
  }));

  return (
    <div className={addInstructorForm ? "instformMOdal" : "instform"}>
      {isLoading && <Loader />}
      <div className="instform_header">
        <h2
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
          onClick={hanldeBack}
        >
          <BackArrowIcon />
          Instructor
        </h2>
      </div>

      <Tabs defaultActiveKey="1">
        <div>
          <div className="instform_content">
            <div className="instform_content_details"></div>
            <div className="instform_wrapper">
              <div className="instform_content_details">
                <div className="instform_content_details_top">
                  <div className="form_field">
                    <FormInputs
                      title="First Name*"
                      placeholder="Enter First Name"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                    {errors.firstName && (
                      <span className="error">{errors.firstName}</span>
                    )}
                  </div>
                  <div className="form_field">
                    <FormInputs
                      title="Last Name*"
                      placeholder="Enter Last Name"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                    {errors.lastName && (
                      <span className="error">{errors.lastName}</span>
                    )}
                  </div>
                  <div className="form_field">
                    <FormInputs
                      title="Email Id*"
                      placeholder="Enter Email Id"
                      name="emailId"
                      value={formData.emailId}
                      onChange={handleChange}
                    />
                    {errors.emailId && (
                      <span className="error">{errors.emailId}</span>
                    )}
                  </div>
                  <div className="form_field phone-input-container">
                    <label>Mobile Number*</label>
                    <PhoneInput
                      country={"in"}
                      value={`${formData.countryCode}${formData.mobileNumber}`}
                      onChange={handlePhoneChange}
                      inputStyle={{
                        width: "100%",
                        borderRadius: "5px",
                        borderColor: "#d9d9d9",
                      }}
                    />
                    {errors.mobileNumber && (
                      <span className="error">{errors.mobileNumber}</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="instform_content_textarea">
                <label htmlFor="notes">About*</label>
                <TextArea
                  id="notes"
                  placeholder="Enter notes here"
                  rows={4}
                  name="aboutMe"
                  value={formData.aboutMe}
                  onChange={handleChange}
                  style={{
                    fontWeight: 600,
                    color: "#717171",
                    fontSize: "16px",
                  }}
                />
                {errors.aboutMe && (
                  <span className="error">{errors.aboutMe}</span>
                )}
              </div>
              <div className="instform_content_details">
                <div className="instform_content_details_top">
                  <div className="form_field">
                    <SelectInputs
                      title="Gender*"
                      name="gender"
                      placeholder="Select Gender"
                      options={[
                        { label: "Male", value: "Male" },
                        { label: "Female", value: "Female" },
                      ]}
                      value={formData.gender || null} // Ensure placeholder shows when no value is selected
                      onChange={(value) => {
                        setFormData({ ...formData, gender: value });

                        // Clear error when gender is selected
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          gender: "",
                        }));
                      }}
                      size="large"
                      style={{ width: "100%" }}
                    />
                    {errors.gender && (
                      <span className="error">{errors.gender}</span>
                    )}
                  </div>
                  <div className="form_field">
                    <FormInputs
                      title="Education*"
                      placeholder="Enter Education"
                      name="education"
                      value={formData.education}
                      onChange={handleChange}
                    />
                    {errors.education && (
                      <span className="error">{errors.education}</span>
                    )}
                  </div>
                  <div className="form_field">
                    <FormInputs
                      type="number"
                      title="Experience*"
                      placeholder="Enter Experience"
                      name="experience"
                      value={formData.experience}
                      onChange={handleChange}
                    />
                    {errors.experience && (
                      <span className="error">{errors.experience}</span>
                    )}
                  </div>
                  <div className="form_field">
                    <MultiSelectInput
                      title="Expertise*"
                      options={categoryOptions}
                      value={formData.expertise || []} // This should be an array of selected IDs
                      onChange={(selectedIds) => {
                        setFormData((prev) => ({
                          ...prev,
                          expertise: selectedIds,
                        }));

                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          expertise:
                            selectedIds.length > 0 ? "" : prevErrors.expertise,
                        }));
                      }}
                      placeholder={
                        <span
                          style={{
                            fontWeight: 600,
                            color: "#717171",
                            fontSize: "16px",
                          }}
                        >
                          Select or enter your expertise
                        </span>
                      }
                    />
                  </div>
                  <div className="form_field">
                    <FormInputs
                      type="number"
                      title="Registration Fee*"
                      placeholder="Enter Registration Fee"
                      name="registrationFee"
                      value={formData.registrationFee}
                      onChange={handleChange}
                    />
                    {errors.registrationFee && (
                      <span className="error">{errors.registrationFee}</span>
                    )}
                  </div>
                  <div className="form_field">
                    <FormInputs
                      type="number"
                      title="Security Fee"
                      placeholder="Enter Security Fee"
                      name="securityFee"
                      value={formData.securityFee}
                      onChange={handleChange}
                    />
                    {errors.securityFee && (
                      <span className="error">{errors.securityFee}</span>
                    )}
                  </div>
                  <div className="form_field">
                    <FormInputs
                      type="number"
                      title="Expected Per Session Fee"
                      placeholder="Enter Expected Per Session Fee"
                      name="expectedPerSessionFee"
                      value={formData.expectedPerSessionFee}
                      onChange={handleChange}
                    />
                    {errors.expectedPerSessionFee && (
                      <span className="error">
                        {errors.expectedPerSessionFee}
                      </span>
                    )}
                  </div>
                  <div className="form_field">
                    <FormInputs
                      type="number"
                      title="Approved Per Session Fee"
                      placeholder="Enter Approved Per Session Fee"
                      name="finalPerSessionFee"
                      value={formData.finalPerSessionFee}
                      onChange={handleChange}
                    />
                    {errors.finalPerSessionFee && (
                      <span className="error">{errors.finalPerSessionFee}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Replace single WeeklySchedule with two side-by-side cards, no Card wrapper */}
          <div className="weekly-schedule-flex">
            <WeeklySchedule
              setSchedule={setSchedule}
              schedule={schedule}
              daylightSchedule={daylightSchedule}
              setDaylightSchedule={setDaylightSchedule}
              onDeleteSlot={handleDeleteSlot}
            />
          </div>
        </div>
      </Tabs>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        {updateData ? (
          <Buttons variant="primary" onClick={handleUpdate}>
            Update
          </Buttons>
        ) : (
          <Buttons variant="primary" onClick={handleSubmit}>
            Save
          </Buttons>
        )}
      </div>
    </div>
  );
};

export default InstructorForm;
